import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { DirectEditService } from '@app/modules/direct/services/direct-edit.service';
import { DirectService } from '../../services/direct.service';

@Component({
  standalone: false,
  selector: 'sbnb-direct-edit-marketing',
  templateUrl: './direct-edit-marketing.component.html',
  styleUrls: ['./direct-edit-marketing.component.scss'],
})
export class DirectEditMarketingComponent implements OnInit {
  googleTagType: 'analytics' | 'tag-manager' = 'analytics';
  marketingForm: UntypedFormGroup;
  saving: boolean;
  recentlySaved = false;
  loading = false;

  constructor(
    public readonly directEditService: DirectEditService,
    private readonly direct: DirectService,
    private fb: UntypedFormBuilder
  ) {}

  ngOnInit(): void {
    this.marketingForm = this.fb.group(
      {
        gaId: [
          '',
          Validators.pattern(
            '^(G-[A-Za-z0-9]+|UA-\\d+-\\d+|AW-\\d+(?:\\/\\d+)?|DC-[A-Za-z0-9]+(?:\\/[A-Za-z0-9]+)?(?:\\/[A-Za-z0-9]+)?|GT-[A-Za-z0-9]+)$'
          ),
        ],
        gtmId: ['', Validators.pattern('^GTM-[a-zA-Z0-9]+$')],
        metaId: [''],
      },
      { updateOn: 'blur' }
    );

    this.getSiteMetas();
  }

  googleTagTypeUpdated(e): void {
    if (e === 'analytics') {
      this.marketingForm.get('gaId').enable();
      this.marketingForm.get('gtmId').disable();
    } else {
      this.marketingForm.get('gaId').disable();
      this.marketingForm.get('gtmId').enable();
    }
  }

  save() {
    if (!this.marketingForm.valid) {
      return;
    }

    this.saving = true;

    const gaId = this.googleTagType === 'analytics' ? this.marketingForm.get('gaId').value : null;

    const gtmId = this.googleTagType === 'tag-manager' ? this.marketingForm.get('gtmId').value : null;

    this.direct
      .updateSiteMetas(this.directEditService.site.id, gaId, gtmId, this.marketingForm.get('metaId').value)
      .subscribe(
        (res) => {
          this.saving = false;
          this.recentlySaved = true;
          setTimeout(() => {
            this.recentlySaved = false;
          }, 3000);
        },
        (err) => {
          this.saving = false;
        }
      );
  }

  getSiteMetas() {
    this.loading = true;
    this.direct.getSiteMetas(this.directEditService.site.id).subscribe((metas) => {
      this.marketingForm.get('gaId').setValue(metas.ga_id);
      this.marketingForm.get('gtmId').setValue(metas.gtm_id);
      this.marketingForm.get('metaId').setValue(metas.meta_pixel_id);

      this.googleTagType = metas.gtm_id ? 'tag-manager' : 'analytics';

      this.loading = false;
    });
  }
}
